import React from 'react';
import PropTypes from 'prop-types';
import { Info } from '@bibliocommons/base-icons';
import { TextButton, SecondarySolidButton } from '@bibliocommons/base-buttons';
import { cardShape, promoShape } from '@bibliocommons/bc-prop-types';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { Table, TableBody, TableRow, TableCell } from '@bibliocommons/table';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import fieldLabels from './fieldLabels';

import './DebugCardButton.scss';

/*
 * NOTE: This component is intended for admins only,
 * hence, the texts are intentionally left untranslated.
 */

function renderTableRow(field, value) {
  const fieldParts = field.match(/\.(\w+).?/);
  const labelId = fieldParts ? fieldParts[1] : field;
  const label = fieldLabels[labelId] || field;

  return (
    <TableRow key={field}>
      <TableCell className="label-cell">{label}</TableCell>
      <TableCell>{value}</TableCell>
    </TableRow>
  );
}

export default class DebugCardButton extends React.PureComponent {
  modalKey = `debug-card-${this.props.card.get('id')}`;

  openModal = () => this.props.modalActions.openModal(this.modalKey);

  closeModal = () => this.props.modalActions.closeModal(this.modalKey);

  renderButton() {
    return (
      <TextButton
        className="debug-card-button"
        dataKey="debug-card-button"
        renderLeadingIcon={() => <Info className="info-icon" />}
        handleClick={this.openModal}
      >
        Debug card
      </TextButton>
    );
  }

  renderTable() {
    const { promo } = this.props;

    return (
      <Table className="promo-table">
        <TableBody>
          {renderTableRow('card_id', promo.get('cardId'))}
          {renderTableRow('confidence', promo.get('confidence'))}
          {renderTableRow('score', promo.get('score'))}
          {promo.get('matches').map(match => renderTableRow(match.get('field'), match.get('values').join(', ')))}
        </TableBody>
      </Table>
    );
  }

  renderModal() {
    return (
      <ModalContainer modalKey={this.modalKey} handleClose={this.closeModal}>
        <ModalHeader title="Debug card" />
        <ModalContent>{this.renderTable()}</ModalContent>
        <ModalFooter
          secondaryActionButtonText="Close"
          secondaryActionButtonTag={SecondarySolidButton}
          renderPrimaryAction={() => null}
        />
      </ModalContainer>
    );
  }

  render() {
    return (
      <div className="cp-debug-card-button">
        {this.renderButton()}
        {this.renderModal()}
      </div>
    );
  }
}

DebugCardButton.propTypes = {
  card: cardShape.isRequired,
  promo: promoShape.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
